import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders1_Holidays() {
  function updateClassBasedOnScreenSize() {
    const element_1 = document.querySelector(".holidays-rem");
    if (!element_1) return; // Exit if element_1 is not found

    if (window.innerWidth >= 1024) {
      element_1.classList.add("mb-5");
       
    } else {
      element_1.classList.remove("mb-5"); 
    }

    const element_2 = document.querySelector(".index-slider");
    if (!element_2) return; 
    if(element_2){
      if (window.innerWidth >= 1024) {
        element_2.classList.add("exclusive-officer-sec");
         
      } else {
        element_2.classList.remove("exclusive-officer-sec"); 
      }
    }
}

// Run on page load and when resizing
window.addEventListener("load", updateClassBasedOnScreenSize);
window.addEventListener("resize", updateClassBasedOnScreenSize);


  const [isScrolled, setIsScrolled] = useState(false);
  
    const settings = {
      slidesToShow: 5, 
      slidesToScroll: 1, 
      autoplay: true,
      autoplaySpeed: 2000, 
      arrows: false, 
      dots: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024, // For screens smaller than 1024px
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768, // For screens smaller than 768px
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 520, // For screens smaller than 520px
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
  
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50);
    };
  
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  
  
  
      const sliderRef = useRef(null);


  return (
    <div>
    <div className="container offers index-slider">
            <div class="holidays-rem popular-state pb-0 pt-0 mb-5 holidays-container-left ">
                <div class="container">
                    <div class="title">
                        <h3 class="pb-0"><span>International </span> Destinations</h3>
                    </div>
                </div>
            </div>

            <div className={`customer-logos slider slides-wrapper ${ isScrolled ? "slider" : ""}`}>
            <Slider ref={sliderRef} {...settings}>
            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/kazakhstan.jpg" alt="" 
                            class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Kazakhstan</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Azerbaijan.jpg" 
                            alt="" class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Azerbaijan</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Abu-Dhabi.jpg" alt="" 
                            class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Abu Dhabi</span> </h2>
                    </div>
                </a>
            </div>
            

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/malaysia.png" 
                            alt="" class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Malaysia</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Srilanka.jpg" alt=""
                             class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Srilanka</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Abu-Dhabi.jpg" alt="" 
                            class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Abu Dhabi</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Abu-Dhabi.jpg" alt="" 
                            class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Abu Dhabi</span> </h2>
                    </div>
                </a>
            </div>
            

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Azerbaijan.jpg" 
                            alt="" class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Azerbaijan</span> </h2>
                    </div>
                </a>
            </div>

            <div class="card swiper-slide">
                <a href="/holidays-list" target="_blank">
                    <div class="image-content">
                        <div class="card-image">
                            <img src="assets/img/tours/international/Turkiye.jpg" 
                            alt="" class="card-img internation-dest-img-sec"/>
                        </div>
                    </div>

                    <div class="card-content">
                        <h2 class="properties-title"><span class="international-country-name">Turkiye</span> </h2>
                    </div>
                </a>
            </div>

            </Slider>
        </div>

          
    </div>
    </div>
  );
}

export default Sliders1_Holidays;
